import { assoc, omit } from 'ramda';

const searchText = (text, q) => {
  const re = new RegExp(q, 'gi');
  return text.toLowerCase().match(re);
};

const searchInUrl = (item, reportsList, q) => {
  if (reportsList[item]) {
    const matchUrl = reportsList[item].reduce((acc, report) => {
      const match = searchText(report.name, q);
      if (!match || !match.length) {
        return acc;
      }
      return acc.concat(report.id);
    }, []);
    if (matchUrl.length) {
      return true;
    }
  }
  return false;
};

const clearTree = (tree, q, reportsList) => {
  if (Array.isArray) {
    const keys = Object.keys(tree);
    // biome-ignore lint/complexity/noExcessiveCognitiveComplexity: legacy code
    const newResults = keys.reduce((acc, key) => {
      const item = tree[key];
      // url from urlList
      if (typeof item === 'string') {
        const match = searchInUrl(item, reportsList, q);
        if (match) {
          return acc.concat(item);
        }
        return acc;
      }
      // // item from urlList
      if (item.url) {
        const match = searchInUrl(item.url, reportsList, q);
        if (match) {
          return acc.concat(item);
        }
        return acc;
      }
      const childrenResults = item.children
        ? clearTree(item.children, q, reportsList)
        : false;
      if (childrenResults?.length) {
        return acc.concat(assoc('children', childrenResults, item));
      }
      const urlListResults = item.urlList
        ? clearTree(item.urlList, q, reportsList)
        : false;
      if (urlListResults?.length) {
        const newItem = assoc('urlList', urlListResults, item);
        if (childrenResults?.length) {
          return acc.concat(newItem);
        }
        return acc.concat(omit('children', newItem));
      }
      return acc;
    }, []);
    return newResults;
  }
  return tree;
};

export default clearTree;
